// @flow
import PostProcessingRule from "./PostProcessingRule";

export const InspectionRegionDecodeMethods = {
    NONE: 0,
    DATA_MATRIX: 1,
    LINEAR: 2,
    OCR: 3,
    COLOR: 4,
    PDF417: 5,
    QR_CODE: 6,
};

export default class InspectionRegion {
    
    postProcessing:PostProcessingRule;
    
    constructor() {
        this.id=0;
        this.name="";
        this.cropTopLeft={isEmpty:true, x:0, y:0};
        this.cropBottomRight={isEmpty:true, x:0, y:0};
        this.finalResize={isEmpty:true, width:0, height:0};
        this.decodeMethod=0;
        this.hint="";
        this.postProcessing =null;
        
    }
    
    FromJson(json) {
        this.id = json.id;
        this.name = json.name;
        this.cropTopLeft = json.cropTopLeft;
        this.cropBottomRight = json.cropBottomRight;
        this.finalResize = json.finalResize;
        this.decodeMethod = json.decodeMethod;
        this.hint = json.hint;
        
        if (json.postProcessing) { // NOTE -- name change here (json name here is actually wrong)
            this.postProcessing = new PostProcessingRule();
            this.postProcessing.FromJson(json.postProcessing); // NOTE -- and here
        }
    }
}